// Google Ads conversion tracking. Labels: Ads → Goals → Conversions → action → Tag setup.
const SEND_TO_PHONE_CLICK = 'AW-17178526678/CF2nCOKL_eUcENaHrv8_';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const SEND_TO_FORM_SUBMIT = 'AW-17178526678/dHTyCJal7-UcENaHrv8_';

export const trackPhoneClick = () =>
  window.gtag?.('event', 'conversion', { send_to: SEND_TO_PHONE_CLICK });

export const trackFormSubmit = () =>
  window.gtag?.('event', 'conversion', { send_to: SEND_TO_FORM_SUBMIT });
